import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/components/ui/toast";
import { ApiError, transferMatch } from "@/lib/api";
import { invalidateScope, unscopedKey } from "@/lib/queryClient";
import type { Match, TransferMatchRequest } from "@/lib/types";

export function useTransferMatch() {
  const client = useQueryClient();
  const toast = useToast();
  return useMutation<
    Match,
    ApiError,
    { id: string; sourceTeamId: string; body: TransferMatchRequest }
  >({
    mutationFn: ({ id, body }) => transferMatch(id, body),
    onSuccess: async (_match, input) => {
      toast.success("Match moved to the destination squad");
      await client.invalidateQueries({
        predicate: (query) =>
          query.queryKey.length >= 4 &&
          [input.sourceTeamId, input.body.destination_team_id].includes(
            query.queryKey[2] as string,
          ),
      });
      await invalidateScope();
      await Promise.all(
        [
          "admin-matches",
          "admin-matches-allowed",
          "public-matches",
          "public-match",
          "team-performance",
          "team-results",
          "club-overview",
          "notifications",
        ].map((domain) =>
          client.invalidateQueries({ queryKey: unscopedKey(domain) }),
        ),
      );
    },
  });
}
